// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopupUserWithMenuItem__hint-ac6425 {
  margin-inline-end: 12px;
}

.PopupUserWithMenuItem__opened-f6df57 {
  background-color: var(--base-30);
}

.PopupUserWithMenuItem__icon-c01c73 {
  width: 24px;
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/Popups/GetParametersManager/components/PopupUserWithMenuItem/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF","sourcesContent":[".hint {\n  margin-inline-end: 12px;\n}\n\n.opened {\n  background-color: var(--base-30);\n}\n\n.icon {\n  width: 24px;\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hint": `PopupUserWithMenuItem__hint-ac6425`,
	"opened": `PopupUserWithMenuItem__opened-f6df57`,
	"icon": `PopupUserWithMenuItem__icon-c01c73`
};
module.exports = ___CSS_LOADER_EXPORT___;
